export default {
  loading: false,
  orderList: [],
  orderhistory:[]
};
